import CryptoJS from "crypto-js";
import { responseEncrypted, secretKey } from "./utils";

function modifySecretKey(key: string) {
  return CryptoJS.SHA256(key); // Derive a 256-bit key using SHA-256
}
export function encrypt(text: string) {
  let key = secretKey;
  const secretKey1 = modifySecretKey(key); // Derive the key
  const iv = CryptoJS.enc.Utf8.parse("678025308de70905");
  const encrypted = CryptoJS.AES.encrypt(text, secretKey1, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString();
  return encrypted;
}
/** Function to Decrypt the data */
export function decrypt(text: string) {
  if (!text) {
    return "";
  }
  try {
    let key = secretKey;
    const secretKey1 = modifySecretKey(key); // Derive the key
    const iv = CryptoJS.enc.Utf8.parse("678025308de70905"); // 16-byte IV
    const decrypted = CryptoJS.AES.decrypt(text, secretKey1, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  } catch (error) {
    console.error("Error decrypting text:", error);
    throw error;
  }
}
export let encryptByText = async (text: string) => {
  let a = text.split("");
  let ae = await Promise.all(
    a.map(async (v) => {
      let data = await encrypt(v);
      return data;
    })
  );
  return ae.join(""); // Join with space or any delimiter
};

export let decryptByText = (encryptedText: string) => {
  try {
    let encryptedComponents = encryptedText.split("=="); // Split by the same delimiter used in encryption
    let decryptedComponents = encryptedComponents.map((comp) => {
      let data = decrypt(comp + "==");
      return data;
    });
    return decryptedComponents?.join("");
  } catch (error) {
    return "";
  }
  // Split the concatenated encrypted text back into its components
};

export let responseDataFormate = (data: any) => {
  if (responseEncrypted == "1") {
    try {
      const decryptedData = decrypt(data);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error("Error formatting response data:", error);
      return null;
    }
  } else {
    return data;
  }
};

export let requestPayloadBodyFormate = (data: any) => {
  if (responseEncrypted == "1") {
    try {
      const newData = JSON.stringify(data);
      const result = encrypt(newData);

      return { data: result };
    } catch (error) {
      return null;
    }
  } else {
    return data;
  }
};

const STORAGE_KEY = "user_data";
const SECRET_KEY_FOR_USER = "XJ79sSWja03DcGEaR"; // 🔐 Use env variable in production

// Encrypt and store user data
export const setEncryptedUserData = (userData: object): void => {
  try {
    const jsonString = JSON.stringify(userData);
    const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY_FOR_USER).toString();
    localStorage.setItem(STORAGE_KEY, encrypted);
  } catch (error) {
    console.error("Encryption error:", error);
  }
};

// Retrieve and decrypt user data
export const getDecryptedUserData = (): object | null => {
  try {
    const encrypted = localStorage.getItem(STORAGE_KEY);
    if (!encrypted) return null;

    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY_FOR_USER);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    const newData = JSON.parse(decrypted);
    const descriptedNewData = {
      ...newData,
      email: decryptByText(newData?.email),
      first_name: decryptByText(newData?.first_name),
      last_name: decryptByText(newData?.last_name),
      name: decryptByText(newData?.first_name) + " " + decryptByText(newData?.last_name),
      full_role_details: newData?.role,
      role: newData?.role,
    };
    return descriptedNewData;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
